/**
 * api接口的统一出口
 */
// login模块接口
import login from '@/network/login';
import system from '@/network/system';
import course from '@/network/course';
import target from '@/network/target';
import goods from '@/network/goods';
import finance from '@/network/finance';
import custom from '@/network/custom';

// 其他模块的接口……

// 导出接口
export default {
  login,
	system,
  course,
  target,
  goods,
  finance,
  custom,
  // ……
}



// WEBPACK FOOTER //
// ./src/api/index.js